import React, { useEffect, useState } from 'react';
import { Loader2, OctagonPause, X } from 'lucide-react';
import { onNodeBusyRequest, answerNodeBusy } from '../../services/nodeBusy';

/**
 * NodeBusyConfirmDialog — E6c.5
 *
 * Mini-modal de tres opciones que aparece antes de mandar otra generación a un
 * nodo que ya tiene una en curso. Se monta UNA vez en el Studio; el store y
 * los hooks lo invocan con `askNodeBusy` y esperan la respuesta.
 */
export const NodeBusyConfirmDialog = () => {
  const [request, setRequest] = useState(null);
  const [working, setWorking] = useState(false);

  useEffect(() => onNodeBusyRequest((req) => {
    setWorking(false);
    setRequest(req);
  }), []);

  if (!request) return null;

  const answer = (value) => {
    if (value === 'stop_and_send') setWorking(true);
    if (value !== 'stop_and_send') setRequest(null);
    answerNodeBusy(value);
    if (value === 'stop_and_send') {
      // El cierre lo hace la propia acción cuando termina de detener.
      setTimeout(() => { setRequest(null); setWorking(false); }, 600);
    }
  };

  const total = request.nodes.reduce((acc, n) => acc + n.running, 0);
  const many = request.nodes.length > 1;
  const plural = total === 1 ? 'generación' : 'generaciones';
  const costo = request.cost ? ` por ${request.cost} cr` : '';

  return (
    <div className="node-busy-overlay" data-testid="node-busy-dialog">
      <div className="node-busy-modal" role="dialog" aria-modal="true">
        <button
          className="node-busy-close"
          onClick={() => answer('cancel')}
          aria-label="Cerrar"
          data-testid="node-busy-close"
        >
          <X size={14} />
        </button>

        <h3 className="node-busy-title">
          {many
            ? `${request.nodes.length} nodos ya están generando`
            : `Este nodo ya tiene ${total} ${plural} en curso.`}
        </h3>

        {many && (
          <ul className="node-busy-list" data-testid="node-busy-nodes">
            {request.nodes.map((n) => (
              <li key={n.nodeId}>
                <Loader2 size={11} className="spin" />
                <span className="node-busy-node-label">{n.label}</span>
                <span className="node-busy-node-count">
                  {n.running} en curso
                </span>
              </li>
            ))}
          </ul>
        )}

        <p className="node-busy-text">
          ¿Mandar otra{costo}? La anterior va a quedar en la galería.
        </p>

        <div className="node-busy-actions">
          <button
            className="node-busy-btn primary"
            onClick={() => answer('send')}
            disabled={working}
            data-testid="node-busy-send"
          >
            Mandar otra
          </button>
          <button
            className="node-busy-btn danger"
            onClick={() => answer('stop_and_send')}
            disabled={working}
            data-testid="node-busy-stop-send"
          >
            {working ? <Loader2 size={12} className="spin" /> : <OctagonPause size={12} />}
            Detener la anterior y mandar
          </button>
          <button
            className="node-busy-btn ghost"
            onClick={() => answer('cancel')}
            disabled={working}
            data-testid="node-busy-cancel"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NodeBusyConfirmDialog;
